import api from '@/api';

export default {
  login: data => api.post('login', data),
  resetPassword: data => api.post('resetPassword', data),
  sendRecoverLink: data => api.post('sendRecoverLink', data),
};
